import angularElasticModule from 'angular-elastic';

import { TextareaComponent } from './textarea.component';

export default angular
  .module('sfMobile.components.textarea', [angularElasticModule])
  .component('sfTextarea', TextareaComponent).name;
